
import OperativeView from './OperativeControl'

import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import compose from 'recompose/compose';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { NavLink, withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';

// Material components
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';
//import RefreshIcon from '@material-ui/icons/Refresh';
//import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
//import InfoIcon from '@material-ui/icons/Info';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
//import Button from '@material-ui/core/Button';
import HelpIcon from '@material-ui/icons/Help';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import StopIcon from '@material-ui/icons/Stop';
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
import UpdateIcon from '@material-ui/icons/Update';
import CloseIcon from '@material-ui/icons/Close';
                                
import {getObjectives} from '../../../../services/getObjectives'
import { reportFetchError } from '../../../../observability/rum';
import Button from '@material-ui/core/Button';
import { getQueryParams } from '../../../../utils/fns/get-query-params';
import { withTranslation } from 'react-i18next';
// Component styles
import styles from './styles';
import moment from 'moment-timezone'
import 'moment/locale/es'
import { Box } from '@material-ui/core';
moment.locale('es')

class QuickView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            typeGraph: 0,
            listObjectives: {},
            loadObjectiveData: false,
            loadError: false,
            dateMoment:moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a"),
            isInfo:null,
            fromBoards: sessionStorage.getItem('fromBoards') === 'true',
            intervalId: null,
        };
    }

    tick=()=>{
        //console.log('recarga cada 5 minutos')
        sessionStorage.setItem("listsLoadsDisponibilidad",false)
        window.location.reload()
        sessionStorage.setItem("listsLoads",false)
        this.setState({
            typeGraph: 0,
            listObjectives: {},
            loadObjectiveData: false,
            dateMoment:moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a"),
            isInfo:null
            
        })
        this.processData()
      }

    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };
    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };

    componentDidMount() {
        const newInterval = setInterval(
            () => this.tick(),
            900000
          )
        this.setState({intervalId: newInterval})
        this.processData()
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId)
    }

    processData = () => {
        sessionStorage.setItem('fromBoards', false)
        const {params}=this.props
        if((sessionStorage.getItem("listsLoads"))==="true"){
            this.setState({
                listObjectives: JSON.parse(sessionStorage.getItem("listaData")),
                loadObjectiveData: true
            });
        }else{
            let token = sessionStorage.getItem('key')
            let user_id = sessionStorage.getItem('user')
            /*OBTIENE OBJETIVOS POR ESTADO*/
            getObjectives(user_id, token).then(data=>{
                sessionStorage.setItem("listaData",JSON.stringify(data))
                this.setState({
                    listObjectives: data,
                    loadObjectiveData: true
                });
            })
            .catch((error) => {
                reportFetchError('QuickView', error)
                this.setState({ loadError: true })
            })
        }
    }

    handleRetry = () => {
        this.setState({ loadError: false }, this.processData);
    };
           

    render() {
        const { classes, className } = this.props;
        const { typeGraph, listObjectives, loadObjectiveData, loadError, dateMoment, isInfo, fromBoards} = this.state;
        const rootClassName = classNames(classes.root, className);
        const showIsInfo = Boolean(isInfo);
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (loadError) {
            return(
                <PortletContent>
                    <Box textAlign="center">
                        <Typography variant="h6">{t('text.load-error')}</Typography>
                        <Button color="primary" onClick={this.handleRetry}>{t('text.retry')}</Button>
                    </Box>
                </PortletContent>
            )
        }
        if (!loadObjectiveData) {
            return(
                <PortletContent>
                    <Typography
                    variant="h5"
                    >
                    <CircularProgress
                    variant="indeterminate"
                    size={24}
                    thickness={4}
                    />
                    <br/>
                    {t('text.loading')}
                    </Typography>
                </PortletContent>
            )
        }
        return (
            <Portlet
                    className={rootClassName}
                >
                    <PortletHeader className={classes.header} style={{borderBottom: "none"}}
                    >
                        {fromBoards ?
                            <div style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <NavLink to={{pathname: '/boards', search: getQueryParams()}}>
                                <Button 
                                style={{color: "#fff", background: "#909090"}}
                                >
                                    Regresar
                                </Button>
                                </NavLink>
                            </div>
                        :null}
                        <PortletLabel
                            variant="h6"
                        />

                        <PortletToolbar>
                            <div>
                                <IconButton
                                onClick={this.handleShowIsInfo}
                                >
                                    <HelpIcon color="infoIcon"/>
                                </IconButton>
                            </div>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <Avatar variant="rounded" className={classes.rounded}>
                                <UpdateIcon />
                                </Avatar>
                                <Typography  className={classes.updateTime}   >
                                        &nbsp; {t('text.last-update')}: {dateMoment}
                                </Typography>
                                
                            </div>
                        </PortletToolbar>
                    </PortletHeader>
                    <PortletContent className={classes.content}>
                        <Grid
                            container
                            spacing={3}
                        >
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                xl={12}>
                                <Grid
                                container
                                direction="row"
                                alignItems="center"
                                style={{paddingTop:"10px"}}
                            >
                                    
                                <Popover
                                    anchorEl={isInfo}
                                    open={showIsInfo}
                                    onClose={this.handleCloseIsInfo}
                                    >
                                        <Box style={{backgroundColor: 'rgba(92, 92, 92, .8)', width: 300}}>
                                            <Box className={classes.buttonClosed} >
                                                <IconButton className={classes.buttonClosed} onClick={this.handleCloseIsInfo}><CloseIcon/></IconButton>
                                            </Box>
                                            <Box style={{padding: 10, paddingTop: 0}}>
                                                <Typography variant="body1" className={classes.textColorPopover} >{t('operative-status.info.0')}
                                                </Typography>
                                                <Divider/>
                                                <Grid
                                                container
                                                direction="row"
                                                alignItems="center"
                                                >
                                                    <StopIcon color="primary" /><Typography variant="body2" className={classes.textColorPopover}>{t('operative-status.info.1')}</Typography>
                                                </Grid>
                                                <Grid
                                                container
                                                direction="row"
                                                alignItems="center"
                                                >
                                                    <StopIcon className={classes.stopYellow} /><Typography variant="body2" className={classes.textColorPopover}>{t('operative-status.info.2')}</Typography>
                                                </Grid>
                                                <Grid
                                                container
                                                direction="row"
                                                alignItems="center"
                                                >
                                                    <StopIcon className={classes.stopGreen} /><Typography variant="body2" className={classes.textColorPopover}>{t('operative-status.info.3')}</Typography>
                                                </Grid>
                                                <Divider/>
                                                <Typography variant="body1" className={classes.textColorPopover}> 
                                                {t('operative-status.info.4')}
                                                </Typography>
                                            </Box>
                                        </Box>
                                </Popover>
                            </Grid>
                                <div style={{paddingTop:"1px"}}>
                                    {<Graph
                                        typeGraph={typeGraph}
                                        onInfo={this.handleInfo}
                                        listObjetivesData={listObjectives}/>}
                                </div>
                            </Grid>
                        </Grid>
                        
                    </PortletContent>
                </Portlet>
        )
    }
}

function Graph(props) {
    const typeGraph = props.typeGraph;
    if (typeGraph === 0) {
        //console.log('a')
        return <OperativeView params={props} />;
    }
}



export default
    compose(withRouter, withStyles(styles), withTranslation())(QuickView);